export const last = (array: any[]) => {
  if (array?.length) {
    return array[array.length - 1];
  }
  return null;
};

export const sum = (array: any[], key: string): number => {
  let sum = 0;
  array.forEach((item) => (sum += item[key]));
  return sum;
};

export const sortByOrder = <T extends { order: number }>(items: T[]) => {
  return [...items].sort((item1: T, item2: T) => {
    if (item1.order < item2.order) {
      return -1;
    } else if (item1.order > item2.order) {
      return 1;
    } else {
      return 0;
    }
  });
};
